<template>
  <div class="image-marker image-marker-container" v-if="src || arquivo" @click="onClick"
    :style="'min-width: ' + ( tamanho ? tamanho : 200 ) + 'px; min-height: ' + ( tamanho ? tamanho : 200 ) + 'px;'">
    <img :src="arquivo.temporary_url" :style="posStyle" class="image" @load="onImageLoad" v-if="arquivo">
    <img :src="src" :style="posStyle" class="image" @load="onImageLoad" v-else>

    <div :style="posStyle" class="mark-container">
      <div v-for="(marker, index) in markers" :key="index" class="marker"
        :id="marker.id"
        :style="{
          width: `${ marker.t }px`,
          height: `${ marker.t }px`,
          left: `calc(${ (marker.x * 100) }% - ${ marker.t / 2 }px)`,
          top: `calc(${ (marker.y * 100) }% - ${ marker.t / 2 }px)`,
          backgroundColor: marker.c,
        }"
      ></div>
    </div>
  </div>
    
</template>

<script>
import _ from 'lodash';

const LAYOUT_REFRESH_DELAY = 200

export default {
  props: {
    id: { type: Number, default: 0 },
    src: { type: String, required: false },
    padding: { type: Number, default: 0 },
    value: { required: false },
    tools: { required: false }, 
    selected: { required: false },
    tamanho: { required: false },
  },
  data () {
    return {
      containerWidth: 1,
      containerHeight: 1,
      imageWidth: 1,
      imageHeight: 1,
      top: 0,
      left: 0,
      width: 1,
      height: 1,
      markers: [], 
      arquivo: null, 
    }
  },
  computed: {
    posStyle () {
      let styles = {
        left: this.left + 'px',
        top: this.top + 'px',
      };

      if ( this.width > 1 ) { 
        styles.width = this.width + 'px';
      }

      if ( this.height > 1 ) { 
        styles.height = this.height + 'px';
      }
        
      return styles;
    },

    selected_marker: function () { 
      if ( !this.tools || !this.tools.length ) { 
        return { 
          cor: 'pink',
          tam: 10,
          info: '?',
        };
      }

      if ( this.tools.length == 1 ) { 
        return this.tools[0];
      }

      return _.get(this.tools, this.selected);
    }
  },
  watch: {
    padding: 'refreshPos',
  },
  mounted () {
    // console.log('V', this.value);

    if ( this.value ) { 
      this.markers = this.value;
    }

    if ( this.id ) { 
      this.$util.loadItem(this, { 
          service: 'arquivos',
          func: 'show', 
          parms: { 
              id: this.id
          }
      })
      .then(res => { 
        this.arquivo = res;

        this.refreshPos()
        window.addEventListener('resize', this.refreshPos)
      });
      return;
    }

    this.refreshPos()
    window.addEventListener('resize', this.refreshPos)
  },
  destroyed () {
    window.removeEventListener('resize', this.refreshPos)
  },
  methods: {
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },

    findMarker (ev) { 
      return this.markers.findIndex(item => item.id == ev.target.id);
    },

    onClick (ev) { 
      console.log('Selected', this.selected, this.selected_marker);

      if ( ev.target.classList.value == 'marker' ) { 
        const marker = this.findMarker(ev);
        
        if ( marker >= 0 ) { 
          this.markers.splice(marker, 1);
        }

        return;
      }

      if ( _.get(ev, 'srcElement.className') != 'mark-container' ) { 
        return;
      }

      if ( !this.selected_marker ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Selecione a ferramenta de marcação.',
          life: 3000
        });
        return;
      }

      let x = ev.offsetX / ev.target.clientWidth;
      let y = ev.offsetY / ev.target.clientHeight;

      this.markers.push(
        { 
          x: x, 
          y: y, 
          c: this.selected_marker.cor, 
          t: this.selected_marker.tam ? parseInt(this.selected_marker.tam) : 10, 
          id: this.uuidv4(), 
        }
      );

      this.$emit('input', this.markers);
    },

    onImageLoad (ev) {
      this.imageWidth = ev.currentTarget.naturalWidth
      this.imageHeight = ev.currentTarget.naturalHeight
      this.refreshPos()
    },
    // recalc left, top, width, height
    // Need a delay to wait the dom refreshing
    refreshPos: _.debounce(function () {
      this.containerWidth = this.$el.clientWidth
      this.containerHeight = this.$el.clientHeight
      let clientWidth = this.containerWidth - this.padding * 2
      let clientHeight = this.containerHeight - this.padding * 2
      let clientRatio = clientWidth / clientHeight
      let imageRatio = this.imageWidth / this.imageHeight
      if (imageRatio > clientRatio) {
        // top & bottom padding
        this.width = clientWidth
        this.left = this.padding
        this.height = this.width / imageRatio
        this.top = this.padding + (clientHeight - this.height) / 2
      } else {
        // left & right padding
        this.height = clientHeight
        this.top = this.padding
        this.width = this.height * imageRatio
        this.left = this.padding + (clientWidth - this.width) / 2
      }
    }, LAYOUT_REFRESH_DELAY),
  },
}
</script>

<style lang="css" scoped>
/*
  min-width: 200px;
  min-height: 200px;
*/

.image-marker {
  position: relative;
}
.image {
  position: absolute;
  border: 1px solid #000;
}
.mark-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

/*
 width: 10px;
 height: 10px;
*/
  
.marker { 
  min-width: 10px;
  min-height: 10px;
  position: absolute;
  border-radius: 6px;
  border: solid 1px silver;
  cursor: pointer;
}
</style>
